import { useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';
import PhotoUpload from '@/components/admin/PhotoUpload';
import Modal from './Modal';

const TEXT = [
  ['title', 'Title'], ['time', 'Time (e.g. 7:00 PM)'], ['location', 'Location'],
  ['department', 'Department / Category'], ['registration_url', 'Registration link (https://…)'], ['registration_label', 'Registration button text'],
];

export default function EventDialog({ event, onClose, onSaved }) {
  const [f, setF] = useState(event);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  const save = async () => {
    if (!f.title) { toast.error('Title is required'); return; }
    setBusy(true);
    try {
      if (f.id) await api.patch(`/events/${f.id}`, f);
      else await api.post('/events', f);
      toast.success('Event saved');
      onSaved();
    } catch { toast.error('Save failed'); } finally { setBusy(false); }
  };

  return (
    <Modal title={f.id ? 'Edit Event' : 'Add Event'} onClose={onClose} testid="event-dialog"
      footer={<>
        <button onClick={onClose} className="px-4 py-2 text-charcoal-muted">Cancel</button>
        <button onClick={save} disabled={busy} data-testid="event-dialog-save" className="btn-royal">{busy ? 'Saving…' : 'Save'}</button>
      </>}>
      <div className="grid md:grid-cols-2 gap-3 text-sm">
        {TEXT.map(([k, label]) => (
          <label key={k} className={k === 'title' ? 'md:col-span-2' : ''}>
            <div className="font-semibold text-royal mb-1">{label}</div>
            <input value={f[k] || ''} onChange={(e) => set(k, e.target.value)} data-testid={`event-field-${k}`} className="w-full px-3 py-2 border rounded" />
          </label>
        ))}
        <label>
          <div className="font-semibold text-royal mb-1">Date</div>
          <input type="date" value={f.date || ''} onChange={(e) => set('date', e.target.value)} data-testid="event-field-date" className="w-full px-3 py-2 border rounded" />
        </label>
        <label>
          <div className="font-semibold text-royal mb-1">Card background color</div>
          <div className="flex items-center gap-2">
            <input type="color" value={f.bg_color || '#ffffff'} onChange={(e) => set('bg_color', e.target.value)} data-testid="event-field-bg_color" />
            {f.bg_color && <button onClick={() => set('bg_color', '')} className="text-xs underline">Reset</button>}
          </div>
        </label>
        <label className="md:col-span-2">
          <div className="font-semibold text-royal mb-1">Description</div>
          <textarea rows={4} value={f.description || ''} onChange={(e) => set('description', e.target.value)} data-testid="event-field-description" className="w-full px-3 py-2 border rounded" />
        </label>
        <div className="md:col-span-2"><PhotoUpload label="Event photo" value={f.image} onChange={(v) => set('image', v)} category="events" /></div>
        <label className="md:col-span-2 flex items-center gap-2">
          <input type="checkbox" checked={!!f.featured} onChange={(e) => set('featured', e.target.checked)} data-testid="event-field-featured" />
          <span className="font-semibold text-royal">Feature on the homepage</span>
        </label>
      </div>
    </Modal>
  );
}
